module.exports = __webpack_public_path__ + "static/img/d-rulebg-kiko.f814b003.png";